"use strict";

export default class FormFileSizeValidation {
    constructor() {
        let self = this;

        $("form").submit(function (e) {
            let listAlertFile = '',
                totalFormFileSize = 0,
                totalUploadedFiles = 0;

            if (typeof FileReader !== "undefined") {
                $("input[type='file']").each(function () {
                    totalUploadedFiles += this.files.length;

                    if (totalUploadedFiles > MAX_FILE_UPLOADS) {
                        alert('The maximum number of files allowed to upload is ' + MAX_FILE_UPLOADS);
                        e.preventDefault();
                    }

                    for (let i = 0; i < this.files.length; i++) {
                        let file = this.files[i];
                        // check file size
                        if (file && file.size > MAX_UPLOAD_SIZE) {
                            listAlertFile += "\n" + file.name;
                        }

                        totalFormFileSize += parseInt(file.size);
                    }
                });

                if (listAlertFile) {
                    alert('Max file size upload is ' + self.formatFileSize(MAX_UPLOAD_SIZE) + ':' + listAlertFile);
                    // prevent submission
                    e.preventDefault();
                } else if (totalFormFileSize > MAX_POST_SIZE) {
                    alert('Total file size cannot exceed: ' + self.formatFileSize(MAX_POST_SIZE));
                    // prevent submission
                    e.preventDefault();
                }
            }
        });
    }

    formatFileSize (bytes,decimalPoint) {
        if ( bytes == 0 ) {
            return '0 Bytes';
        }

        let k = 1024,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}
